import { forwardRef } from "react";
function SvgRawEnvelopeIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <rect
        width={18}
        height={14}
        x={3}
        y={5}
        stroke="#1D1D1D"
        strokeLinejoin="round"
        strokeWidth={2}
        rx={2}
      />
      <path
        stroke="#1D1D1D"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M3 7a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1.35a1 1 0 0 1-.594.914L12 13 3.594 9.264A1 1 0 0 1 3 8.35V7Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawEnvelopeIcon);
export default ForwardRef;
